module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-panel', [_c('h2', [_vm._v("Donation Summary")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "check-ticket"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-layout', [_vm._v("\n                test\n            ")])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242a70c0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/donate/summary/summary.vue
// module id = 799
// module chunks = 0